import { render } from "./PuntosColombia.vue?vue&type=template&id=5bc4bdfc"
import script from "./PuntosColombia.vue?vue&type=script&lang=js"
export * from "./PuntosColombia.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__